module.exports = __webpack_public_path__ + "static/assets/ff262f7b3a4cbb95a0ba9c030dfdb30e.jpg";